module.exports = __webpack_public_path__ + "img/bg.75832ed2.png";